import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

const ThemeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.1rem;
  background: var(--color-surface);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  cursor: pointer;
  font-size: 0.9rem;
  text-align: left;
  transition: transform 0.25s var(--transition-smooth), border-color 0.25s var(--transition-smooth), box-shadow 0.25s var(--transition-smooth);
  width: 100%;

  &:hover {
    transform: translateY(-2px);
    border-color: var(--color-accent);
    box-shadow: var(--shadow-soft);
  }
`;

export const ThemeToggleButton: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  return (
    <ThemeButton
      onClick={toggleTheme}
      type="button"
      aria-label={`Switch to ${isLight ? 'dark' : 'light'} mode`}
      data-track-event="theme_toggle"
      data-track-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
      data-track-context="sidebar"
    >
      <FontAwesomeIcon icon={isLight ? faMoon : faSun} />
      {isLight ? 'Dark Mode' : 'Light Mode'}
    </ThemeButton>
  );
};
